import { Component } from '@angular/core';
import { ROUTER_UTILS } from '@core/utils/router.utils';

@Component({
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
  path = ROUTER_UTILS.config.base;
}
